// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"5026d669","237":"15165e08","264":"590bd5f2","412":"c3b11a29","431":"b6acde88","440":"c418459d","638":"74bd7db3"}[chunkId] + ".chunk.js";
};